<template>
  <div>
    <div class="title_h1">緑地化計画一覧</div>
    <vab-row class="row_box margin_bottom_16">
      <vab-col :span="4" class="title_box border_left border_bottom">
        建物
      </vab-col>
      <vab-col :span="20" class="word_box border_bottom border_right">
        <div class="flex_space flex_center_align">
          <div class="flex_auto line_height">セントラルフィールド中目黒</div>
          <div class="sub_title">（建物CD：A0130）</div>
        </div>
      </vab-col>
    </vab-row>
    <el-row>
      <el-col>
        <vab-table
          ref="table"
          api-url="/api/greeningPlans/partner/pager"
          :columns="columns"
          :custom-config="false"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'PWR02G07',
    data() {
      return {
        columns: [
          {
            label: '年計No',
            'min-width': 160,
            prop: 'nkno',
            fixed: 'left',
          },
          {
            label: '年計枝番',
            'min-width': 98,
            prop: 'nkeb',
            fixed: 'left',
          },
          {
            label: '協力会社',
            'min-width': 240,
            prop: 'bcnfrkj',
            fixed: 'left',
          },
          {
            label: '状況名称',
            'min-width': 98,
            prop: 'syeb',
          },
          {
            label: '年計No',
            'min-width': 160,
            prop: 'syeb',
          },
          {
            label: '年計枝番',
            'min-width': 98,
            prop: 'nkeb',
          },
          {
            label: '協力会社',
            'min-width': 240,
            prop: 'bcnfrkj',
          },
          {
            label: '見積名称',
            'min-width': 240,
            prop: 'estnm',
          },
          {
            label: '担当者',
            'min-width': 140,
            prop: 'chempcd',
          },
          {
            label: 'FM社員',
            'min-width': 140,
            prop: 'fmempcd',
          },
          {
            label: 'GL社員',
            'min-width': 140,
            prop: 'acempcd',
          },
          {
            label: 'MP社員',
            'min-width': 140,
            prop: 'mpempcd',
          },
          {
            label: '管理開始日',
            'min-width': 140,
            prop: 'knmstrtm',
          },
          {
            label: '登録ユーザー',
            'min-width': 140,
            prop: 'crtusr',
          },
          {
            label: '変更ユーザー',
            'min-width': 140,
            prop: 'chgusr',
          },
          {
            label: '決算月',
            'min-width': 86,
            prop: 'stlmn',
          },
        ],
      }
    },
  }
</script>

<style scoped>
  .margin_bottom_16 {
    margin-bottom: 16px;
  }
</style>
